import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from 'material-ui';
import { t } from '../i18n';

const ErrorSnackbar = (props) => {
  const {
    onRetry,
    autoHideDuration,
    ...rest
  } = props;

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      action="retry"
      onActionClick={onRetry}
      {...rest}
    />
  );
};

ErrorSnackbar.propTypes = {
  ...Snackbar.propTypes,
  onRetry: PropTypes.func.isRequired,
  autoHideDuration: PropTypes.number,
};

ErrorSnackbar.defaultProps = {
  message: t('Error occurred'),
  autoHideDuration: 3000,
};

export default ErrorSnackbar;



// WEBPACK FOOTER //
// ./src/components/ErrorSnackbar.js